import styled from '@emotion/styled';

import { Link } from 'react-router-dom';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography, IconButton, Tooltip } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import EditIconRounded from '@mui/icons-material/EditRounded';

import { BasicFlex, Notes } from '../../../utils/Common';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

import { formatCurrency, formatPhoneNumber } from '../../../utils/util';

import { getContactList } from '../apiService';

import { useQuery } from '@tanstack/react-query';

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1px 10px;
`;

const Contact = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 3px 18px 3px 6px;
  border-radius: 4px;
  line-height: 1.25;
  &:hover { background: #f3f6fb; }
  &:hover .remove-btn { opacity: 1; }
`;

const CName = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CPhone = styled.span`
  font-size: 11px;
  color: #888;
`;

const DetailsTab = () => {
  const { data = {} } = usePageData();

  const { data: contacts } = useQuery({
    queryKey: ['contact_groups', data?.contact_group_id, 'contacts'],
    queryFn: () => getContactList(data?.contact_group_id),
    enabled: !!data?.contact_group_id
  })

  const basicBlock = [
    {header: "Name", info: data.name},
    {header: "Description", info: data.description},
    {header: "Number of Contacts", info: data.num_of_contacts},
    {header: "Date Created", info: data.created_at, dataType: "date"},
  ]

  return (
    <Grid container spacing={3}>
      <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title="Basic Details" action={<Tooltip title="Edit Contact Group"><Link to={`/contact_groups/edit/${data?.contact_group_id}`}><IconButton><EditIconRounded fontSize='small' color='secondary' /></IconButton></Link></Tooltip>} />
          <CardContent>

            <CardBlockContainer>
              {basicBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
            </CardBlockContainer>
           
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{xs: 12, md: 8}}>
        <Card variant='outlined'>
          <CardHeader title={`List of Contacts (${data?.num_of_contacts})`} />
          <CardContent>
            <ContactGrid>
              {contacts?.map((contact) => (
                <Contact key={contact.customer_id}>
                  <CName>{contact.full_name}</CName>
                  <CPhone>{formatPhoneNumber(contact.mobile_phone)}</CPhone>
                </Contact>
              ))}
            </ContactGrid>
          </CardContent>
        </Card>
      </Grid>

    </Grid>
  );

};

export default DetailsTab;